// assets/variant-description.js
(function () {
  function readMap() {
    var script = document.getElementById('variant_metafield_description_variant');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (e) {
      console.warn('[variant-description] Nu pot parsa JSON-ul din #variant_metafield_description_variant', e);
      return null;
    }
  }

  function renderVariantDescription(variantId) {
    var el = document.getElementById('variant-description');
    if (!el) return;

    var map = readMap();
    if (!map) return;

    el.innerHTML = map[String(variantId)] || '';
  }

  function getCurrentVariantIdFallback() {
    var input = document.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  function init() {
    // 1) initial (la load)
    var initialId = getCurrentVariantIdFallback();
    if (initialId) renderVariantDescription(initialId);

    // 2) varianta “corecta” in Dawn: pub/sub
    // subscribe() si PUB_SUB_EVENTS sunt globale in Dawn (daca sunt, le folosim).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
        var variantId = payload && payload.data && payload.data.variant && payload.data.variant.id;
        if (variantId) renderVariantDescription(variantId);
      });
      return;
    }

    // 3) fallback: asculta schimbarea input-ului de variant id
    var variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) return;

    variantInput.addEventListener('change', function () {
      renderVariantDescription(this.value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
